module.exports = "/_next/static/images/flexibility-and-security-332d87a5d48aa2dc7f18298dcea7d09c.svg";